const Delivery = Object.freeze({
    PICKUP: 'PICKUP',
    UNDEFINED: 'UNDEFINED',
    AROUNDTOWN: 'AROUNDTOWN',
    AROUNDCOUNTRY: 'AROUNDCOUNTRY',
  });
  
  export default Delivery;